let configCache = null;

export const getConfig = async () => {
  if (configCache) {
    return configCache;
  }

  const configPath = `/config.json`;

  const response = await fetch(configPath, { cache: "no-store" });

  if (!response.ok) {
    throw new Error(`Cannot load config from ${configPath} (status: ${response.status})`);
  }

  configCache = await response.json();
  return configCache;
};

export const getDatabaseKey = async () => {
  const config = await getConfig();
  return config.databasekey;
};

export const getApiBaseUrl = async () => {
  const config = await getConfig();
  return config.API_BASE_URL;
};

export const getdatabasekey = async () => {
  const config = await getConfig();
  return config.databasekey;
};

export const getKeyMode = async () => {
  const config = await getConfig();
  return config.KeyMode?.toLowerCase() === "custom" ? "custom" : "fixed";
};

export const getAllowedUsers = async () => {
  const config = await getConfig();
  return config.allowedUsers;
};

export const getCookieDays = async () => {
  const config = await getConfig();
  return config.cookieDays ?? 7;
};

export const getTheme = async () => {
  const config = await getConfig();
  const theme = config.theme || "Cupcake";
  return theme;
};

export const getCompanyName = async () => {
  const config = await getConfig();
  return config.CompanyName || "DEMO";
};


export const getAuthUsername = async () => {
  const config = await getConfig();
  return config.AUTH_USERNAME;
};

export const getAuthPassword = async () => {
  const config = await getConfig();
  return config.AUTH_PASSWORD;
};

export const getAiBaseUrl = async () => {
  const config = await getConfig();
  return config.AI_BASE_URL;
};

export const getAiGeminiUrl = async () => {
  const config = await getConfig();
  return config.AI_Gemini_URL;
};

export const getAiRevampUrl = async () => {
  const config = await getConfig();
  return config.AI_Revamp_URL;
};

export const getPermissions = async () => {
  const config = await getConfig();
  return config.permissions || {};
};
